export const FETCH_BACKTEST_BY_ID_REQUEST = 'FETCH_BACKTEST_BY_ID_REQUEST';
export const FETCH_BACKTEST_BY_ID_SUCCESS = 'FETCH_BACKTEST_BY_ID_SUCCESS';
export const FETCH_BACKTEST_BY_ID_FAILURE = 'FETCH_BACKTEST_BY_ID_FAILURE';
export const FETCH_ALGOS_DAY_WISE_REQUEST = 'FETCH_ALGOS_DAY_WISE_REQUEST';
export const FETCH_ALGOS_DAY_WISE_SUCCESS = 'FETCH_ALGOS_DAY_WISE_SUCCESS';
export const FETCH_ALGOS_DAY_WISE_FAILURE = 'FETCH_ALGOS_DAY_WISE_FAILURE';
export const FETCH_BACKTESTS_REQUEST = 'FETCH_BACKTESTS_REQUEST';
export const FETCH_BACKTESTS_SUCCESS = 'FETCH_BACKTESTS_SUCCESS';
export const FETCH_BACKTESTS_FAILURE = 'FETCH_BACKTESTS_FAILURE';
export const BACKTEST_CREATE_REQUEST = 'BACKTEST_CREATE_REQUEST';
export const BACKTEST_RENAME_REQUEST = 'BACKTEST_RENAME_REQUEST';
export const BACKTEST_CREATE_WITH_CONFIG_REQUEST =
  'BACKTEST_CREATE_WITH_CONFIG_REQUEST';
export const BACKTEST_DELETE_REQUEST = 'BACKTEST_DELETE_REQUEST';
export const BACKTEST_UPDATE_REQUEST = 'BACKTEST_UPDATE_REQUEST';
export const BACKTEST_RUN_REQUEST = 'BACKTEST_UPDATE_REQUEST';
export const BACKTEST_ADD_LEG = 'BACKTEST_ADD_LEG';
export const BACKTEST_TOGGLE_LEG = 'BACKTEST_TOGGLE_LEG';
export const BACKTEST_TOGGLE_TRANSACTIONTYPE =
  'BACKTEST_TOGGLE_TRANSACTIONTYPE';
export const BACKTEST_CHANGE_QUANTITY = 'BACKTEST_CHANGE_QUANTITY';
export const BACKTEST_DELETE_LEG = 'BACKTEST_DELETE_LEG';
export const BACKTEST_UPDATE_CONFIG = 'BACKTEST_UPDATE_CONFIG';

export const FETCH_ALGO_BY_ID_REQUEST = 'FETCH_ALGO_BY_ID_REQUEST';
export const FETCH_ALGO_BY_ID_SUCCESS = 'FETCH_ALGO_BY_ID_SUCCESS';
export const FETCH_ALGO_BY_ID_FAILURE = 'FETCH_ALGO_BY_ID_FAILURE';
export const FETCH_ALGOS_REQUEST = 'FETCH_ALGOS_REQUEST';
export const FETCH_ALGOS_SUCCESS = 'FETCH_ALGOS_SUCCESS';
export const FETCH_ALGOS_FAILURE = 'FETCH_ALGOS_FAILURE';
export const ALGO_CREATE_REQUEST = 'ALGO_CREATE_REQUEST';
export const ALGO_RENAME_REQUEST = 'ALGO_RENAME_REQUEST';
export const ALGO_CREATE_WITH_CONFIG_REQUEST =
  'ALGO_CREATE_WITH_CONFIG_REQUEST';
export const ALGO_DELETE_REQUEST = 'ALGO_DELETE_REQUEST';
export const ALGO_UPDATE_REQUEST = 'ALGO_UPDATE_REQUEST';
export const ALGO_DUPLICATE_REQUEST = 'ALGO_DUPLICATE_REQUEST';
export const ALGO_RUN_REQUEST = 'ALGO_UPDATE_REQUEST';
export const ALGO_ADD_LEG = 'ALGO_ADD_LEG';
export const ALGO_TOGGLE_LEG = 'ALGO_TOGGLE_LEG';
export const ALGO_TOGGLE_MATCH_PREMIUM = 'ALGO_TOGGLE_MATCH_PREMIUM';
export const ALGO_TOGGLE_TRANSACTIONTYPE = 'ALGO_TOGGLE_TRANSACTIONTYPE';
export const ALGO_TOGGLE_SIDE = 'ALGO_TOGGLE_SIDE';
export const ALGO_TOGGLE_BASE_INSTRUMENT = 'ALGO_TOGGLE_BASE_INSTRUMENT';
export const ALGO_CHANGE_QUANTITY = 'ALGO_CHANGE_QUANTITY';
export const ALGO_CHANGE_STRIKE = 'ALGO_CHANGE_STRIKE';
export const ALGO_DELETE_LEG = 'ALGO_DELETE_LEG';
export const ALGO_UPDATE_CONFIG = 'ALGO_UPDATE_CONFIG';
export const ALGO_CHANGE_LEG_TARGET_TYPE = 'ALGO_CHANGE_LEG_TARGET_TYPE';
export const ALGO_CHANGE_LEG_STOPLOSS_TYPE = 'ALGO_CHANGE_LEG_STOPLOSS_TYPE';
export const ALGO_CHANGE_LEG_TRAILING_STOPLOSS_TYPE =
  'ALGO_CHANGE_LEG_TRAILING_STOPLOSS_TYPE';
export const ALGO_CHANGE_LEG_TARGET_VALUE = 'ALGO_CHANGE_LEG_TARGET_VALUE';
export const ALGO_CHANGE_LEG_STOPLOSS_VALUE = 'ALGO_CHANGE_LEG_STOPLOSS_VALUE';
export const ALGO_CHANGE_LEG_TRAILING_STOPLOSS_MOVE_BY_VALUE =
  'ALGO_CHANGE_LEG_TRAILING_STOPLOSS_MOVE_BY_VALUE';
export const ALGO_CHANGE_LEG_TRAILING_STOPLOSS_TRAIL_BY_VALUE =
  'ALGO_CHANGE_LEG_TRAILING_STOPLOSS_TRAIL_BY_VALUE';
export const ALGO_CHANGE_LEG_STOPLOSS_TRAILING =
  'ALGO_CHANGE_LEG_STOPLOSS_TRAILING';
export const ALGO_CHANGE_LEG_TYPE_REENTRY = 'ALGO_CHANGE_LEG_TYPE_REENTRY';
export const ALGO_CHANGE_LEG_VALUE_REENTRY = 'ALGO_CHANGE_LEG_VALUE_REENTRY';
export const ALGO_CHANGE_LEG_REENTRY = 'ALGO_CHANGE_LEG_REENTRY';
export const ALGO_TOGGLE_REQUEST = 'ALGO_TOGGLE_REQUEST';
export const ALGO_TOGGLE_DONE = 'ALGO_TOGGLE_DONE';
export const ALGO_TOGGLE_SUCCESS = 'ALGO_TOGGLE_SUCCESS';
export const ALGO_SQ_OFF_ALL_REQUEST = 'ALGO_SQ_OFF_ALL_REQUEST';
export const ALGO_TERMINATE_REQUEST = 'ALGO_TERMINATE_REQUEST';
export const ALGO_UPDATE_STOPLOSS_TRAILING = 'ALGO_UPDATE_STOPLOSS_TRAILING';
export const ALGO_BROKER_CHANGE_REQUEST = 'ALGO_BROKER_CHANGE_REQUEST';
export const ALGO_BROKER_CHANGE_SUCCESS = 'ALGO_BROKER_CHANGE_SUCCESS';
export const ALGO_LEG_PRODUCT_TOGGLE = 'ALGO_LEG_PRODUCT_TOGGLE';
export const ALGO_CHANGE_LEG_WAIT_AND_TRADE_TYPE =
  'ALGO_CHANGE_LEG_WAIT_AND_TRADE_TYPE';
export const ALGO_CHANGE_LEG_WAIT_AND_TRADE_RESET =
  'ALGO_CHANGE_LEG_WAIT_AND_TRADE_RESET';
export const ALGO_CHANGE_LEG_WAIT_AND_TRADE_VALUE =
  'ALGO_CHANGE_LEG_WAIT_AND_TRADE_VALUE';
export const ALGO_CHANGE_PREMIUM = 'ALGO_CHANGE_PREMIUM';
export const ALGO_CHANGE_LEG_PROPS = 'ALGO_CHANGE_LEG_PROPS';

export const FETCH_ALGOS_CONFIG_REQUEST = 'FETCH_ALGOS_CONFIG_REQUEST';
export const FETCH_ALGOS_CONFIG_SUCCESS = 'FETCH_ALGOS_CONFIG_SUCCESS';
export const FETCH_ALGOS_CONFIG_FAILURE = 'FETCH_ALGOS_CONFIG_FAILURE';

export const FETCH_USER_REQUEST = 'FETCH_USER_REQUEST';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE';
export const USER_UPDATE_CONFIG = 'USER_UPDATE_CONFIG';
export const USER_UPDATE_REQUEST = 'USER_UPDATE_REQUEST';
export const USER_PASSWORD_CHANGE_REQUEST = 'USER_PASSWORD_CHANGE_REQUEST';
export const USER_NAME_CHANGE_REQUEST = 'USER_PASSWORD_CHANGE_REQUEST';

export const FETCH_BACKTESTS_RESULT_REQUEST = 'FETCH_BACKTESTS_RESULT_REQUEST';
export const FETCH_BACKTESTS_RESULT_SUCCESS = 'FETCH_BACKTESTS_RESULT_SUCCESS';
export const FETCH_BACKTESTS_RESULT_FAILURE = 'FETCH_BACKTESTS_RESULT_FAILURE';

export const LIVE_ORDER_API_RUNNING = 'LIVE_ORDER_API_RUNNING';
export const LIVE_ORDER_API_NOT_RUNNING = 'LIVE_ORDER_API_NOT_RUNNING';
export const LIVE_LIVE_FEED_RUNNING = 'LIVE_LIVE_FEED_RUNNING';
export const LIVE_LIVE_FEED_NOT_RUNNING = 'LIVE_LIVE_FEED_NOT_RUNNING';
export const LIVE_ALGO_RUNNING = 'LIVE_ALGO_RUNNING';
export const LIVE_ALGO_NOT_RUNNING = 'LIVE_ALGO_NOT_RUNNING';
export const LIVE_ORDER_API_REQUEST = 'LIVE_ORDER_API_REQUEST';
export const LIVE_ORDER_API_SUCCESS = 'LIVE_ORDER_API_SUCCESS';
export const LIVE_ORDER_API_FAILURE = 'LIVE_ORDER_API_FAILURE';
export const LIVE_LIVE_FEED_REQUEST = 'LIVE_LIVE_FEED_REQUEST';
export const LIVE_LIVE_FEED_SUCCESS = 'LIVE_LIVE_FEED_SUCCESS';
export const LIVE_LIVE_FEED_FAILURE = 'LIVE_LIVE_FEED_FAILURE';
export const LIVE_ALGO_REQUEST = 'LIVE_ALGO_REQUEST';
export const LIVE_ALGO_SUCCESS = 'LIVE_ALGO_SUCCESS';
export const LIVE_ALGO_FAILURE = 'LIVE_ALGO_FAILURE';

export const FETCH_ALGOS_LIVE_REQUEST = 'FETCH_ALGOS_LIVE_REQUEST';
export const FETCH_ALGOS_LIVE_SUCCESS = 'FETCH_ALGOS_LIVE_SUCCESS';
export const FETCH_ALGOS_LIVE_FAILURE = 'FETCH_ALGOS_LIVE_FAILURE';
export const FETCH_ALGO_LIVE_BY_ID_REQUEST = 'FETCH_ALGO_LIVE_BY_ID_REQUEST';
export const FETCH_ALGO_LIVE_BY_ID_SUCCESS = 'FETCH_ALGO_LIVE_BY_ID_SUCCESS';
export const FETCH_ALGO_LIVE_BY_ID_FAILURE = 'FETCH_ALGO_LIVE_BY_ID_FAILURE';

export const FETCH_ALGOS_TYPES_REQUEST = 'FETCH_ALGOS_TYPES_REQUEST';
export const FETCH_ALGOS_TYPES_SUCCESS = 'FETCH_ALGOS_TYPES_SUCCESS';
export const FETCH_ALGOS_TYPES_FAILURE = 'FETCH_ALGOS_TYPES_FAILURE';

export const FETCH_BROKERS_REQUEST = 'FETCH_BROKERS_REQUEST';
export const FETCH_BROKERS_SUCCESS = 'FETCH_BROKERS_SUCCESS';
export const FETCH_BROKERS_FAILURE = 'FETCH_BROKERS_FAILURE';
export const FETCH_BROKERS_LIST_REQUEST = 'FETCH_BROKERS_LIST_REQUEST';
export const FETCH_BROKERS_LIST_SUCCESS = 'FETCH_BROKERS_LIST_SUCCESS';
export const FETCH_BROKERS_LIST_FAILURE = 'FETCH_BROKERS_LIST_FAILURE';
export const FETCH_BROKER_BY_ID_REQUEST = 'FETCH_BROKER_BY_ID_REQUEST';
export const FETCH_BROKER_BY_ID_SUCCESS = 'FETCH_BROKER_BY_ID_SUCCESS';
export const FETCH_BROKER_BY_ID_FAILURE = 'FETCH_BROKER_BY_ID_FAILURE';
export const CLEAR_BROKER_BY_ID = 'CLEAR_BROKER_BY_ID';
export const BROKER_UPDATE_CONFIG = 'BROKER_UPDATE_CONFIG';
export const BROKER_DELETE_REQUEST = 'BROKER_DELETE_REQUEST';
export const BROKER_EANBLE_REQUEST = 'BROKER_EANBLE_REQUEST';

export const NOTIFICATION_ADD_ENTRY = 'NOTIFICATION_ADD_ENTRY';
export const ORDER_UPDATE_ENTRY = 'ORDER_UPDATE_ENTRY';
export const NOTIFICATION_DELETE_ENTRY = 'NOTIFICATION_DELETE_ENTRY';
export const NOTIFICATION_CLEAR_ALL = 'NOTIFICATION_CLEAR_ALL';

export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const ORDER_BOOK_FETCHED = 'ORDER_BOOK_FETCHED';
export const ORDER_GROUP_FETCHED = 'ORDER_GROUP_FETCHED';
export const ORDER_GROUP_REMOVED = 'ORDER_GROUP_REMOVED';
export const USER_LOGGED_IN = 'USER_LOGGED_IN';
export const ORDER_UPDATE = 'ORDER_UPDATE';
export const EMIT = 'EMIT';
export const SET_GLOBAL_DATA = 'SET_GLOBAL_DATA';
export const LIVE_FEED = 'LIVE_FEED';

export const SUBSCRIBE_POSITION_UPDATES = 'SUBSCRIBE_POSITION_UPDATES';
export const UNSUBSCRIBE_POSITION_UPDATES = 'UNSUBSCRIBE_POSITION_UPDATES';
export const ORDER_UPDATES = 'ORDER_UPDATES';
export const SUBSCRIBE_LITE_POSITION_UPDATES =
  'SUBSCRIBE_LITE_POSITION_UPDATES';
export const UNSUBSCRIBE_LITE_POSITION_UPDATES =
  'UNSUBSCRIBE_LITE_POSITION_UPDATES';
export const LITE_POSITION_UPDATES = 'LITE_POSITION_UPDATES';

export const UNDERLYING_LIVE_FEED = 'UNDERLYING_LIVE_FEED';
export const UNDERLYING_LIVE_FEED_CONVERSION_MAP =
  'UNDERLYING_LIVE_FEED_CONVERSION_MAP';
export const SUBSCRIBE_UNDERLYING_LIVE_FEED = 'SUBSCRIBE_UNDERLYING_LIVE_FEED';
export const UNSUBSCRIBE_UNDERLYING_LIVE_FEED =
  'UNSUBSCRIBE_UNDERLYING_LIVE_FEED';

export const BROKER_STATUS_UPDATE = 'BROKER_STATUS_UPDATE';
export const ANNOUNCEMENT_UPDATE = 'ANNOUNCEMENT_UPDATE';

// status
export const FETCH_ALGO_STATUS_REQUEST = 'FETCH_ALGO_STATUS_REQUEST';
export const FETCH_ALGO_STATUS_SUCCESS = 'FETCH_ALGO_STATUS_SUCCESS';
export const FETCH_ALGO_STATUS_FAILURE = 'FETCH_ALGO_STATUS_FAILURE';

// socket connected
export const SOCKET_CONNECTION_UNKNOWN = 'SOCKET_CONNECTION_UNKNOWN';
export const SOCKET_CONNECTION_CONNECT = 'SOCKET_CONNECTION_CONNECT';
export const SOCKET_CONNECTION_DISCONNECT = 'SOCKET_CONNECTION_DISCONNECT';
export const SOCKET_CONNECTION_RECONNECT = 'SOCKET_CONNECTION_RECONNECT';

// monitors
export const MONITOR_UPDATE = 'MONITOR_UPDATE';

// algo status update
export const ALGO_STATUS_UPDATE = 'ALGO_STATUS_UPDATE';
export const ALGO_STATUS_CLEAR = 'ALGO_STATUS_CLEAR';

// Health status
export const HEALTH_STATUS = 'HEALTH_STATUS';
export const CLEAR_HEALTH_STATUS = 'CLEAR_HEALTH_STATUS';

// master contracts
export const GET_MASTER_CONTRACTS_REQUEST = 'GET_MASTER_CONTRACTS_REQUEST';
export const GET_MASTER_CONTRACTS_SUCCESS = 'GET_MASTER_CONTRACTS_SUCCESS';
export const GET_MASTER_CONTRACTS_FAILURE = 'GET_MASTER_CONTRACTS_FAILURE';
export const MASTER_CONTRACTS_CHECK_DONE = 'MASTER_CONTRACTS_CHECK_DONE';

export const FETCH_MY_REFERRALS_REQUEST = 'FETCH_MY_REFERRALS_REQUEST';
export const FETCH_MY_REFERRALS_SUCCESS = 'FETCH_MY_REFERRALS_SUCCESS';
export const FETCH_MY_REFERRALS_FAILURE = 'FETCH_MY_REFERRALS_FAILURE';

// credits
export const FETCH_CREDITS_REQUEST = 'FETCH_CREDITS_REQUEST';
export const FETCH_CREDITS_SUCCESS = 'FETCH_CREDITS_SUCCESS';
export const FETCH_CREDITS_FAILURE = 'FETCH_CREDITS_FAILURE';

// subscription-plans
export const FETCH_SUBSCRIPTION_PLANS_REQUEST =
  'FETCH_SUBSCRIPTION_PLANS_REQUEST';
export const FETCH_SUBSCRIPTION_PLANS_SUCCESS =
  'FETCH_SUBSCRIPTION_PLANS_SUCCESS';
export const FETCH_SUBSCRIPTION_PLANS_FAILURE =
  'FETCH_SUBSCRIPTION_PLANS_FAILURE';

// subscription COUPONS
export const FETCH_SUBSCRIPTION_COUPONS_REQUEST =
  'FETCH_SUBSCRIPTION_COUPONS_REQUEST';
export const FETCH_SUBSCRIPTION_COUPONS_SUCCESS =
  'FETCH_SUBSCRIPTION_COUPONS_SUCCESS';
export const FETCH_SUBSCRIPTION_COUPONS_FAILURE =
  'FETCH_SUBSCRIPTION_PLANS_FAILURE';

// Checkout preview
export const FETCH_CHECKOUT_PREVIEW_REQUEST = 'FETCH_CHECKOUT_PREVIEW_REQUEST';
export const FETCH_CHECKOUT_PREVIEW_SUCCESS = 'FETCH_CHECKOUT_PREVIEW_SUCCESS';
export const FETCH_CHECKOUT_PREVIEW_FAILURE = 'FETCH_CHECKOUT_PREVIEW_FAILURE';
export const CLEAR_CHECKOUT_PREVIEW = 'CLEAR_CHECKOUT_PREVIEW';

// Checkout preview
export const FETCH_CHECKOUT_EDIT_PREVIEW_REQUEST =
  'FETCH_CHECKOUT_EDIT_PREVIEW_REQUEST';
export const FETCH_CHECKOUT_EDIT_PREVIEW_SUCCESS =
  'FETCH_CHECKOUT_EDIT_PREVIEW_SUCCESS';
export const FETCH_CHECKOUT_EDIT_PREVIEW_FAILURE =
  'FETCH_CHECKOUT_EDIT_PREVIEW_FAILURE';
export const CLEAR_CHECKOUT_EDIT_PREVIEW = 'CLEAR_CHECKOUT_EDIT_PREVIEW';

// Checkout preview only immediate
export const FETCH_CHECKOUT_EDIT_PREVIEW_ONLY_IMMEDIATE_REQUEST =
  'FETCH_CHECKOUT_EDIT_PREVIEW_ONLY_IMMEDIATE_REQUEST';
export const FETCH_CHECKOUT_EDIT_PREVIEW_ONLY_IMMEDIATE_SUCCESS =
  'FETCH_CHECKOUT_EDIT_PREVIEW_ONLY_IMMEDIATE_SUCCESS';
export const FETCH_CHECKOUT_EDIT_PREVIEW_ONLY_IMMEDIATE_FAILURE =
  'FETCH_CHECKOUT_EDIT_PREVIEW_ONLY_IMMEDIATE_FAILURE';

export const FETCH_ALGOS_DAY_WISE_REFRESH_REQUEST =
  'FETCH_ALGOS_DAY_WISE_REFRESH_REQUEST';
export const FETCH_ALGOS_DAY_WISE_REFRESH_SUCCESS =
  'FETCH_ALGOS_DAY_WISE_REFRESH_SUCCESS';
export const FETCH_ALGOS_DAY_WISE_REFRESH_FAILURE =
  'FETCH_ALGOS_DAY_WISE_REFRESH_FAILURE';

// status
export const EXPIRY_NOTIFICATION_VISIBLE = 'EXPIRY_NOTIFICATION_VISIBLE';
export const EXPIRY_NOTIFICATION_NOT_VISIBLE =
  'EXPIRY_NOTIFICATION_NOT_VISIBLE';

// theme
export const THEME_TOGGLE = 'THEME_TOGGLE';
export const ALGO_SELECT_SET = 'ALGO_SELECT_SET';

// Health status
export const ALGOS_HEALTH_STATUS = 'ALGOS_HEALTH_STATUS';
export const CLEAR_ALGOS_HEALTH_STATUS = 'CLEAR_ALGOS_HEALTH_STATUS';

export const FETCH_ALGOS_LIST_REQUEST = 'FETCH_ALGOS_LIST_REQUEST';
export const FETCH_ALGOS_LIST_SUCCESS = 'FETCH_ALGOS_LIST_SUCCESS';
export const FETCH_ALGOS_LIST_FAILURE = 'FETCH_ALGOS_LIST_FAILURE';

export const CACHE_ALGOS_LIST = 'CACHE_ALGOS_LIST';

export const ALGOS_LIST_CONFIG_LOADING_START =
  'ALGOS_LIST_CONFIG_LOADING_START';
export const ALGOS_LIST_CONFIG_LOADING_STOP = 'ALGOS_LIST_CONFIG_LOADING_STOP';
export const ALGOS_LIST_CONFIG_SELECTED_DAY = 'ALGOS_LIST_CONFIG_SELECTED_DAY';
export const ALGOS_LIST_CONFIG_SORTING = 'ALGOS_LIST_CONFIG_SORTING';
export const ALGOS_LIST_CONFIG_ERRORS = 'ALGOS_LIST_CONFIG_ERRORS';
export const ALGOS_LIST_COMMON_CHANGE = 'ALGOS_LIST_COMMON_CHANGE';
export const ALGOS_LIST_CHANGE_ENABLE = 'ALGOS_LIST_CHANGE_ENABLE';
export const ALGOS_LIST_CHANGE_ENABLE_LOADING =
  'ALGOS_LIST_CHANGE_ENABLE_LOADING';
export const ALGOS_LIST_CHANGE_ENABLE_ERROR = 'ALGOS_LIST_CHANGE_ENABLE_ERROR';
export const ALGOS_LIST_CHANGE_BROKER = 'ALGOS_LIST_CHANGE_BROKER';
export const ALGOS_LIST_CHANGE_MODAL_ERROR = 'ALGOS_LIST_CHANGE_MODAL_ERROR';
export const ALGOS_LIST_COMMON_UPPEND_DATA = 'ALGOS_LIST_COMMON_UPPEND_DATA';
export const ALGOS_LIST_CONFIG_RENAME_INIT = 'ALGOS_LIST_CONFIG_RENAME_INIT';
export const ALGOS_LIST_CONFIG_DELETE_INIT = 'ALGOS_LIST_CONFIG_DELETE_INIT';
export const ALGOS_LIST_CHANGE_DELETE_ALGO = 'ALGOS_LIST_CHANGE_DELETE_ALGO';
export const ALGOS_LIST_CHANGE_SELECT = 'ALGOS_LIST_CHANGE_SELECT';
export const ALGOS_LIST_CONFIG_FILTER = 'ALGOS_LIST_CONFIG_FILTER';
export const ALGOS_LIST_CHANGE_BULK_SELECT = 'ALGOS_LIST_CHANGE_BULK_SELECT';
export const ALGOS_LIST_CONFIG_BULK_CLEAR = 'ALGOS_LIST_CONFIG_BULK_CLEAR';
export const ALGOS_LIST_UPDATE_SKIP_CLEANER = 'ALGOS_LIST_UPDATE_SKIP_CLEANER';
export const ALGOS_LIST_CHANGE_SHIFT_SELECT = 'ALGOS_LIST_CHANGE_SHIFT_SELECT';
export const ALGOS_LIST_CONFIG_PAGE_LOADING_TRUE =
  'ALGOS_LIST_CONFIG_PAGE_LOADING_TRUE';
export const ALGOS_LIST_CONFIG_PAGE_LOADING_FALSE =
  'ALGOS_LIST_CONFIG_PAGE_LOADING_FALSE';
export const ALGOS_LIST_CHANGE_BULK_DUPLICATE_ALGO =
  'ALGOS_LIST_CHANGE_BULK_DUPLICATE_ALGO';
export const ALGOS_LIST_CONFIG_BULK_DELETE_INIT =
  'ALGOS_LIST_CONFIG_BULK_DELETE_INIT';
export const ALGOS_LIST_CONFIG_BULK_DUPLICATE_INIT =
  'ALGOS_LIST_CONFIG_BULK_DUPLICATE_INIT';
export const ALGOS_LIST_CHANGE_BULK_DELETE_ALGO =
  'ALGOS_LIST_CHANGE_BULK_DELETE_ALGO';
export const ALGOS_LIST_CONFIG_BULK_MULTIPLIER_INIT =
  'ALGOS_LIST_CONFIG_BULK_MULTIPLIER_INIT';
export const ALGOS_LIST_CHANGE_BULK_MULTIPLIER =
  'ALGOS_LIST_CHANGE_BULK_MULTIPLIER';
export const ALGOS_LIST_CHANGE_CLEAR_ALL_SELECT =
  'ALGOS_LIST_CHANGE_CLEAR_ALL_SELECT';
export const ALGOS_LIST_CONFIG_BULK_MTM_MODIFY_INIT =
  'ALGOS_LIST_CONFIG_BULK_MTM_MODIFY_INIT';
export const ALGOS_LIST_CONFIG_DUPLICATE_ALGO_INIT =
  'ALGOS_LIST_CONFIG_DUPLICATE_ALGO_INIT';
export const ALGOS_LIST_CONFIG_TERMINATE_INIT =
  'ALGOS_LIST_CONFIG_TERMINATE_INIT';
export const ALGOS_LIST_CONFIG_BULK_TERMINATE_INIT =
  'ALGOS_LIST_CONFIG_BULK_TERMINATE_INIT';
export const ALGOS_LIST_CONFIG_BULK_SQOFF_TERMINATE_INIT =
  'ALGOS_LIST_CONFIG_BULK_SQOFF_TERMINATE_INIT';
export const ALGOS_LIST_CONFIG_SET_TOTAL_PNL_LENGTH =
  'ALGOS_LIST_CONFIG_SET_TOTAL_PNL_LENGTH';
export const ALGOS_LIST_CONFIG_BULK_ENABLE_INIT =
  'ALGOS_LIST_CONFIG_BULK_ENABLE_INIT';
export const ALGOS_LIST_CHANGE_BULK_ENABLE_ALGO =
  'ALGOS_LIST_CHANGE_BULK_ENABLE_ALGO';
export const ALGOS_LIST_CHANGE_BULK_CLEAR_SPECIFIC =
  'ALGOS_LIST_CHANGE_BULK_CLEAR_SPECIFIC';
export const ALGOS_LIST_CONFIG_BULK_DISABLE_INIT =
  'ALGOS_LIST_CONFIG_BULK_DISABLE_INIT';
export const ALGOS_LIST_CHANGE_BULK_DISABLE_ALGO =
  'ALGOS_LIST_CHANGE_BULK_DISABLE_ALGO';
export const ALGOS_LIST_CONFIG_SHIFT_PRESSED =
  'ALGOS_LIST_CONFIG_SHIFT_PRESSED';
export const ALGOS_LIST_FORCE_UPDATE = 'ALGOS_LIST_FORCE_UPDATE';
export const ALGOS_LIST_CONFIG_MULTI_SELECT = 'ALGOS_LIST_CONFIG_MULTI_SELECT';
export const ALGOS_LIST_CHANGE_MULTIPLIER = 'ALGOS_LIST_CHANGE_MULTIPLIER';
export const ALGOS_LIST_CHANGE_MULTIPLIER_CACHE =
  'ALGOS_LIST_CHANGE_MULTIPLIER_CACHE';
export const ALGOS_LIST_CHANGE_MULTIPLIER_RESET =
  'ALGOS_LIST_CHANGE_MULTIPLIER_RESET';
export const ALGOS_LIST_CHANGE_MULTIPLIER_LOADING =
  'ALGOS_LIST_CHANGE_MULTIPLIER_LOADING';

export const ALGO_EDIT_CONFIG_SETTINGS_TOGGLE_CLIENT_ID_SHOW =
  'ALGO_EDIT_CONFIG_SETTINGS_TOGGLE_CLIENT_ID_SHOW';
export const ALGO_EDIT_CONFIG_MODIFY_WHILE_LIVE_ON =
  'ALGO_EDIT_CONFIG_MODIFY_WHILE_LIVE_ON';
export const ALGO_EDIT_CONFIG_MODIFY_WHILE_LIVE_OFF =
  'ALGO_EDIT_CONFIG_MODIFY_WHILE_LIVE_OFF';
export const ALGO_EDIT_CONFIG_MODIFY_WHILE_LIVE_CANCEL =
  'ALGO_EDIT_CONFIG_MODIFY_WHILE_LIVE_CANCEL';
export const ALGO_EDIT_CONFIG_MODIFY_WHILE_LIVE_SAVE =
  'ALGO_EDIT_CONFIG_MODIFY_WHILE_LIVE_SAVE';
export const ALGO_EDIT_CONFIG_MODIFY_WHILE_LIVE_SAVE_START =
  'ALGO_EDIT_CONFIG_MODIFY_WHILE_LIVE_SAVE_START';
export const ALGO_EDIT_CONFIG_MODIFY_WHILE_LIVE_SAVE_STOP =
  'ALGO_EDIT_CONFIG_MODIFY_WHILE_LIVE_SAVE_STOP';

export const ALGO_EDIT_CONFIG_SETTINGS_TERMINATE_START =
  'ALGO_EDIT_CONFIG_SETTINGS_TERMINATE_START';

export const ALGO_EDIT_CONFIG_SETTINGS_TERMINATE_STOP =
  'ALGO_EDIT_CONFIG_SETTINGS_TERMINATE_STOP';

export const ALGO_EDIT_CONFIG_SETTINGS_SQ_OFF_START =
  'ALGO_EDIT_CONFIG_SETTINGS_SQ_OFF_START';

export const ALGO_EDIT_CONFIG_SETTINGS_SQ_OFF_STOP =
  'ALGO_EDIT_CONFIG_SETTINGS_SQ_OFF_STOP';

export const ALGO_EDIT_UPDATE_CREATE_LEG_DATA =
  'ALGO_EDIT_UPDATE_CREATE_LEG_DATA';

export const ALGO_EDIT_UPDATE_CONFIG_DATA = 'ALGO_EDIT_UPDATE_CONFIG_DATA';

export const ALGO_EDIT_CREATE_LEG = 'ALGO_EDIT_CREATE_LEG';
export const ALGO_EDIT_UPDATE_CONFIG_LEG_DATA =
  'ALGO_EDIT_UPDATE_CONFIG_LEG_DATA';

export const ALGO_EDIT_BULK_EDIT_LEG_PREMIUM_INPUT_INCREMENT =
  'ALGO_EDIT_BULK_EDIT_LEG_PREMIUM_INPUT_INCREMENT';

export const ALGO_EDIT_LEG_MULTI_SELECT = 'ALGO_EDIT_LEG_MULTI_SELECT';

export const ALGO_EDIT_JOURNEY_SELECT_UPDATE =
  'ALGO_EDIT_JOURNEY_SELECT_UPDATE';

export const ALGO_EDIT_OPEN_POSITION_TABLE_MODAL =
  'ALGO_EDIT_OPEN_POSITION_TABLE_MODAL';
export const ALGO_EDIT_CLOSE_POSITION_TABLE_MODAL =
  'ALGO_EDIT_CLOSE_POSITION_TABLE_MODAL';

export const ALGO_EDIT_DELETE_CONFIG_LEG = 'ALGO_EDIT_DELETE_CONFIG_LEG';
export const ALGO_EDIT_DUPLICATE_CONFIG_LEG = 'ALGO_EDIT_DUPLICATE_CONFIG_LEG';
export const ALGO_EDIT_DUPLICAT_CONFIG_LEG_LOADING =
  'ALGO_EDIT_DUPLICAT_CONFIG_LEG_LOADING';

export const ALGO_EDIT_PAGE_LOADED_TRUE = 'ALGO_EDIT_PAGE_LOADED_TRUE';
export const ALGO_EDIT_PAGE_LOADED_FALSE = 'ALGO_EDIT_PAGE_LOADED_FALSE';

export const ALGO_EDIT_UPDATE_PROFIT_LOCK_TRAILING_SL =
  'ALGO_EDIT_UPDATE_PROFIT_LOCK_TRAILING_SL';

export const ALGO_EDIT_SAVE_START = 'ALGO_EDIT_SAVE_START';
export const ALGO_EDIT_SAVE_STOP = 'ALGO_EDIT_SAVE_STOP';
export const ALGO_EDIT_VALIDATE_BEFORE_SAVE = 'ALGO_EDIT_VALIDATE_BEFORE_SAVE';
export const ALGO_EDIT_VALIDATION_START = 'ALGO_EDIT_VALIDATION_START';
export const ALGO_EDIT_VALIDATION_FAILURE = 'ALGO_EDIT_VALIDATION_FAILURE';
export const ALGO_EDIT_VALIDATION_CLEAR = 'ALGO_EDIT_VALIDATION_CLEAR';
export const ALGO_EDIT_CHANGE_LEG_INDEX = 'ALGO_EDIT_CHANGE_LEG_INDEX';
export const ALGO_EDIT_PRE_SAVE_CONFIG_FIX = 'ALGO_EDIT_PRE_SAVE_CONFIG_FIX';

export const SIDEBAR_TOGGLE = 'SIDEBAR_TOGGLE';

export const ALGO_EDIT_CONFIGURATION_DECORATOR =
  'ALGO_EDIT_CONFIGURATION_DECORATOR';

export const ALGO_EDIT_CHANGE_NAME = 'ALGO_EDIT_CHANGE_NAME';
export const ALGO_EDIT_CONFIG_RESET = 'ALGO_EDIT_CONFIG_RESET';

export const ALGO_EDIT_CONFIG_SAVE_EABLED = 'ALGO_EDIT_CONFIG_SAVE_EABLED';
export const ALGO_EDIT_CONFIG_SAVE_DISABLED = 'ALGO_EDIT_CONFIG_SAVE_DISABLED';

export const ALGO_EDIT_CREATE_ALGO_REQUEST = 'ALGO_EDIT_CREATE_ALGO_REQUEST';
export const ALGO_EDIT_CREATE_ALGO_SUCCESS = 'ALGO_EDIT_CREATE_ALGO_SUCCESS';
export const ALGO_EDIT_CREATE_ALGO_ERROR = 'ALGO_EDIT_CREATE_ALGO_ERROR';

export const ALGO_EDIT_CONFIG_CREATE_MODAL_OPEN =
  'ALGO_EDIT_CONFIG_CREATE_MODAL_OPEN';
export const ALGO_EDIT_CONFIG_CREATE_MODAL_CLOSE =
  'ALGO_EDIT_CONFIG_CREATE_MODAL_CLOSE';

export const ALGO_EDIT_CONFIRMATIONS_POSITIONAL_MIS =
  'ALGO_EDIT_CONFIRMATIONS_POSITIONAL_MIS';

export const ALGO_EDIT_CONFIRMATIONS_POSITIONAL_MIS_DONE =
  'ALGO_EDIT_CONFIRMATIONS_POSITIONAL_MIS_DONE';

export const ALGOS_LIST_CONFIG_CLIENT_WISE_SQOFF_TERMINATE_INIT =
  'ALGOS_LIST_CONFIG_CLIENT_WISE_SQOFF_TERMINATE_INIT';

export const ALGOS_LIST_CONFIG_CLIENT_WISE_TERMINATE_INIT =
  'ALGOS_LIST_CONFIG_CLIENT_WISE_TERMINATE_INIT';

export const ALGOS_LIST_CONFIG_CLIENT_WISE_SET_TARGET_INIT =
  'ALGOS_LIST_CONFIG_CLIENT_WISE_SET_TARGET_INIT';

export const ALGOS_LIST_CONFIG_MASS_PNL = 'ALGOS_LIST_CONFIG_MASS_PNL';

export const ALGO_LIVE_TOGGLE_SELECT_LEG = 'ALGO_LIVE_TOGGLE_SELECT_LEG';

export const ALGO_LIVE_SELECT_LEG_ALL = 'ALGO_LIVE_SELECT_LEG_ALL';

export const ALGO_LIVE_EXIT_SELECTED_START = 'ALGO_LIVE_EXIT_SELECTED_START';
export const ALGO_LIVE_EXIT_SELECTED_STOP = 'ALGO_LIVE_EXIT_SELECTED_STOP';

export const ALGO_LIVE_UPDATE_SYMBOLS = 'ALGO_LIVE_UPDATE_SYMBOLS';
export const ALGO_LIVE_RESET = 'ALGO_LIVE_RESET';

export const ALGOS_LIST_CONFIG_TOGGLE_CLIENT_ID =
  'ALGOS_LIST_CONFIG_TOGGLE_CLIENT_ID';
export const ALGOS_LIST_CONFIG_TOGGLE_MTM = 'ALGOS_LIST_CONFIG_TOGGLE_MTM';

export const REPORT_CHANGE_PEROID = 'REPORT_CHANGE_PEROID';
export const REPORT_CHANGE_DAY = 'REPORT_CHANGE_DAY';
export const REPORT_CHANGE_START_DAY = 'REPORT_CHANGE_START_DAY';
export const REPORT_CHANGE_END_DAY = 'REPORT_CHANGE_END_DAY';
export const REPORT_SET_ERRORS = 'REPORT_SET_ERRORS';
export const REPORT_CHANGE_RESET_DAY = 'REPORT_CHANGE_RESET_DAY';
export const REPORT_CHANGE_RESET_RANGE = 'REPORT_CHANGE_RESET_RANGE';
export const REPORT_SET_LOADING = 'REPORT_SET_LOADING';

export const ALGOS_LIST_CHANGE_SQOFF_LOADING =
  'ALGOS_LIST_CHANGE_SQOFF_LOADING';

export const CREATE_ALGO_PAGE_LOADED_FALSE = 'CREATE_ALGO_PAGE_LOADED_FALSE';
export const CREATE_ALGO_PAGE_LOADED_TRUE = 'CREATE_ALGO_PAGE_LOADED_TRUE';

export const LOCAL_SETTINGS_SOUND_TOGGLE = 'LOCAL_SETTINGS_SOUND_TOGGLE';
export const SET_LOCAL_SETTINGS_EXPIRY_NOTIFICATION_CLOSE =
  'SET_LOCAL_SETTINGS_EXPIRY_NOTIFICATION_CLOSE';
export const LOCAL_SETTINGS_PNL_IN_TAB_TOGGLE =
  'LOCAL_SETTINGS_PNL_IN_TAB_TOGGLE';
export const LOCAL_SETTINGS_UNDERLYING_PRICE_TICKER_TOGGLE =
  'LOCAL_SETTINGS_UNDERLYING_PRICE_TICKER_TOGGLE';
export const LOCAL_SETTINGS_SHOW_ORDER_ID_TOGGLE =
  'LOCAL_SETTINGS_SHOW_ORDER_ID_TOGGLE';

export const LOCAL_SETTINGS_LAYOUT_LOGIN_MARGIN_TOP =
  'LOCAL_SETTINGS_LAYOUT_LOGIN_MARGIN_TOP';

// Broker setup screen
export const BROKER_SETUP_CLEAR_FORM = 'BROKER_SETUP_CLEAR_FORM';
export const BROKER_SETUP_SCREEN_UPDATE_FORM =
  'BROKER_SETUP_SCREEN_UPDATE_FORM';
export const BROKER_SETUP_SET_FORM_STRUCTURE =
  'BROKER_SETUP_SET_FORM_STRUCTURE';
export const BROKER_SETUP_APP_URIS_REQUEST = 'BROKER_SETUP_APP_URIS_REQUEST';
export const BROKER_SETUP_APP_URIS_SUCCESS = 'BROKER_SETUP_APP_URIS_SUCCESS';
export const BROKER_SETUP_APP_URIS_FAILURE = 'BROKER_SETUP_APP_URIS_FAILURE';
export const BROKER_SETUP_SAVE_CONFIG_REQUEST =
  'BROKER_SETUP_SAVE_CONFIG_REQUEST';
export const BROKER_SETUP_SAVE_CONFIG_SUCCESS =
  'BROKER_SETUP_SAVE_CONFIG_SUCCESS';
export const BROKER_SETUP_SAVE_CONFIG_FAILURE =
  'BROKER_SETUP_SAVE_CONFIG_FAILURE';

// Broker login screen
export const BROKER_LOGIN_CLEAR_FORM = 'BROKER_LOGIN_CLEAR_FORM';
export const BROKER_LOGIN_SCREEN_UPDATE_FORM =
  'BROKER_LOGIN_SCREEN_UPDATE_FORM';
export const BROKER_LOGIN_SET_FORM_STRUCTURE =
  'BROKER_LOGIN_SET_FORM_STRUCTURE';
export const BROKER_LOGIN_REQUEST = 'BROKER_LOGIN_REQUEST';
export const BROKER_LOGIN_SUCCESS = 'BROKER_LOGIN_SUCCESS';
export const BROKER_LOGIN_FAILURE = 'BROKER_LOGIN_FAILURE';

// BOT Notifications
export const FETCH_BOT_NOTIFICATIONS_REQUEST =
  'FETCH_BOT_NOTIFICATIONS_REQUEST';
export const FETCH_BOT_NOTIFICATIONS_SUCCESS =
  'FETCH_BOT_NOTIFICATIONS_SUCCESS';
export const FETCH_BOT_NOTIFICATIONS_FAILURE =
  'FETCH_BOT_NOTIFICATIONS_FAILURE';

// Notice Board
export const NOTICE_BOARD_UPDATE_LOGIN_TIME = 'NOTICE_BOARD_UPDATE_LOGIN_TIME';
export const NOTICE_BOARD_UPDATE_REMIND_LATER =
  'NOTICE_BOARD_UPDATE_REMIND_LATER';
export const NOTICE_BOARD_UPDATE_DO_NOT_SHOW =
  'NOTICE_BOARD_UPDATE_DO_NOT_SHOW';
export const NOTICE_BOARD_UPDATE_NOTICE_VERSION =
  'NOTICE_BOARD_UPDATE_NOTICE_VERSION';

// Algos list stats
export const UPDATE_ALGOS_LIST_STATS = 'UPDATE_ALGOS_LIST_STATS';

// custom signup
export const CUSTOM_SIGNUP_FETCH_DETAILS_REQUEST =
  'CUSTOM_SIGNUP_FETCH_DETAILS_REQUEST';
export const CUSTOM_SIGNUP_FETCH_DETAILS_SUCCESS =
  'CUSTOM_SIGNUP_FETCH_DETAILS_SUCCESS';
export const CUSTOM_SIGNUP_FETCH_DETAILS_FAILURE =
  'CUSTOM_SIGNUP_FETCH_DETAILS_FAILURE';
export const CUSTOM_SIGNUP_UPDATE_DETAILS = 'CUSTOM_SIGNUP_UPDATE_DETAILS';
export const CUSTOM_SIGNUP_RESET_DETAILS = 'CUSTOM_SIGNUP_RESET_DETAILS';

// algos-list-table-settings
export const ALGO_LIST_TABLE_SETTINGS_SAVE_COLUMN_TOGGLE =
  'ALGO_LIST_TABLE_SETTINGS_SAVE_COLUMN_TOGGLE';

// symbol live feed
export const SYMBOL_LIVE_FEED = 'SYMBOL_LIVE_FEED';
export const SYMBOL_LIVE_FEED_RESET = 'SYMBOL_LIVE_FEED_RESET';

// Algos live stats
export const UPDATE_ALGOS_LIVE_STATS = 'UPDATE_ALGOS_LIVE_STATS';

// PNLChart
export const FETCH_PNL_CHART_DATA_REQUEST = 'FETCH_PNL_CHART_DATA_REQUEST';
export const FETCH_PNL_CHART_DATA_SUCCESS = 'FETCH_PNL_CHART_DATA_SUCCESS';
export const FETCH_PNL_CHART_NEXT_DATA_SUCCESS =
  'FETCH_PNL_CHART_NEXT_DATA_SUCCESS';
export const FETCH_PNL_CHART_DATA_FAILURE = 'FETCH_PNL_CHART_DATA_FAILURE';
export const PNL_CHART_DATA_RESET = 'PNL_CHART_DATA_RESET';

export const SUBSCRIBE_CHART_PNL_LIVE_FEED = 'SUBSCRIBE_CHART_PNL_LIVE_FEED';
export const UNSUBSCRIBE_CHART_PNL_LIVE_FEED =
  'UNSUBSCRIBE_CHART_PNL_LIVE_FEED';
export const CHART_PNL_LIVE_FEED = 'CHART_PNL_LIVE_FEED';
export const CHART_PNL_UPDATE_LAST_VALUE = 'CHART_PNL_UPDATE_LAST_VALUE';

export const FETCH_PNL_CHART_UNDERLYING_DATA_REQUEST =
  'FETCH_PNL_CHART_UNDERLYING_DATA_REQUEST';
export const FETCH_PNL_CHART_UNDERLYING_DATA_SUCCESS =
  'FETCH_PNL_CHART_UNDERLYING_DATA_SUCCESS';
export const FETCH_PNL_CHART_UNDERLYING_NEXT_DATA_SUCCESS =
  'FETCH_PNL_CHART_UNDERLYING_NEXT_DATA_SUCCESS';
export const FETCH_PNL_CHART_UNDERLYING_DATA_FAILURE =
  'FETCH_PNL_CHART_UNDERLYING_DATA_FAILURE';
export const PNL_CHART_UNDERLYING_DATA_RESET =
  'PNL_CHART_UNDERLYING_DATA_RESET';

export const SUBSCRIBE_UNDERLYINNG_CHART_PNL_LIVE_FEED =
  'SUBSCRIBE_UNDERLYINNG_CHART_PNL_LIVE_FEED';
export const UNSUBSCRIBE_UNDERLYINNG_CHART_PNL_LIVE_FEED =
  'UNSUBSCRIBE_UNDERLYINNG_CHART_PNL_LIVE_FEED';
export const CHART_UNDERLYINNG_PNL_LIVE_FEED =
  'CHART_UNDERLYINNG_PNL_LIVE_FEED';

//

export const FETCH_PNL_CHART_CLIENT_ID_LIST_REQUEST =
  'FETCH_PNL_CHART_CLIENT_ID_LIST_REQUEST';
export const FETCH_PNL_CHART_CLIENT_ID_LIST_SUCCESS =
  'FETCH_PNL_CHART_CLIENT_ID_LIST_SUCCESS';
export const FETCH_PNL_CHART_CLIENT_ID_LIST_FAILURE =
  'FETCH_PNL_CHART_CLIENT_ID_LIST_FAILURE';

export const SELECT_PNL_CHART_CLIENT_ID_DATA =
  'SELECT_PNL_CHART_CLIENT_ID_DATA';

export const UPDATE_PNL_CHART_CLIENT_ID_FILTER_SEARCH =
  'UPDATE_PNL_CHART_CLIENT_FILTER_SEARCH';

export const UPDATE_PNL_CHART_CLIENT_ID_CACHE =
  'UPDATE_PNL_CHART_CLIENT_ID_CACHE';

export const PNL_CHART_CHART_CLIENT_ID_LIST_RESET =
  'PNL_CHART_CHART_CLIENT_ID_LIST_RESET';

//

export const FETCH_PNL_CHART_ALGO_LIST_REQUEST =
  'FETCH_PNL_CHART_ALGO_LIST_REQUEST';
export const FETCH_PNL_CHART_ALGO_LIST_SUCCESS =
  'FETCH_PNL_CHART_ALGO_LIST_SUCCESS';
export const FETCH_PNL_CHART_ALGO_LIST_FAILURE =
  'FETCH_PNL_CHART_ALGO_LIST_FAILURE';

export const SELECT_PNL_CHART_ALGO_DATA = 'SELECT_PNL_CHART_ALGO_DATA';

export const UPDATE_PNL_CHART_ALGO_FILTER_SEARCH =
  'UPDATE_PNL_CHART_CLIENT_FILTER_SEARCH';

export const UPDATE_PNL_CHART_ALGO_FILTER_BROKER =
  'UPDATE_PNL_CHART_ALGO_FILTER_BROKER';

export const UPDATE_PNL_CHART_ALGO_CACHE = 'UPDATE_PNL_CHART_ALGO_CACHE';

export const PNL_CHART_CHART_ALGO_LIST_RESET =
  'PNL_CHART_CHART_ALGO_LIST_RESET';
//

export const UPDATE_PNL_CHART_FETCH_OPTIONS = 'UPDATE_PNL_CHART_FETCH_OPTIONS';

export const UPDATE_PNL_CHART_CALC_OPTIONS = 'UPDATE_PNL_CHART_CALC_OPTIONS';

export const PNL_CHART_RESET = 'PNL_CHART_RESET';

export const CHART_STORE_UPDATE = 'CHART_STORE_UPDATE';
export const CHART_STORE_REMOVE = 'CHART_STORE_REMOVE';
export const CHART_STORE_FORCE_DATA = 'CHART_STORE_FORCE_DATA';

// Broker url login

export const FETCH_BROKER_LOGIN_URLS_REQUEST =
  'FETCH_BROKER_LOGIN_URLS_REQUEST';
export const FETCH_BROKER_LOGIN_URLS_SUCCESS =
  'FETCH_BROKER_LOGIN_URLS_SUCCESS';
export const FETCH_BROKER_LOGIN_URLS_FAILURE =
  'FETCH_BROKER_LOGIN_URLS_FAILURE';

export const UPDATE_ALGO_LIST_TOTAL_LTP_PERIOD =
  'UPDATE_ALGO_LIST_TOTAL_LTP_PERIOD';

// Misc Modal
export const MISC_MODAL_ADD = 'MISC_MODAL_ADD';
export const MISC_MODAL_REMOVE = 'MISC_MODAL_REMOVE';

// signals list
export const FETCH_SIGNALS_LIST_REQUEST = 'FETCH_SIGNALS_LIST_REQUEST';
export const FETCH_SIGNALS_LIST_SUCCESS = 'FETCH_SIGNALS_LIST_SUCCESS';
export const FETCH_SIGNALS_LIST_FAILURE = 'FETCH_SIGNALS_LIST_FAILURE';
export const CACHE_SIGNALS_LIST = 'CACHE_SIGNALS_LIST';
export const UPDATE_SIGNALS_LIST_FILTERS = 'UPDATE_SIGNALS_LIST_FILTERS';
export const SIGNALS_LIST_TABLE_SETTINGS_SAVE_COLUMN_TOGGLE =
  'SIGNALS_LIST_TABLE_SETTINGS_SAVE_COLUMN_TOGGLE';
export const SIGNALS_LIST_TABLE_MULTI_SELECT =
  'SIGNALS_LIST_TABLE_MULTI_SELECT';
export const SIGNALS_LIST_TABLE_SHIFT_PRESSED =
  'SIGNALS_LIST_TABLE_SHIFT_PRESSED';
export const SIGNALS_LIST_TABLE_SORTING = 'SIGNALS_LIST_TABLE_SORTING';
export const SIGNALS_LIST_CHANGE_ENABLE = 'SIGNALS_LIST_CHANGE_ENABLE';
export const SIGNALS_LIST_CHANGE_ENABLE_LOADING =
  'SIGNALS_LIST_CHANGE_ENABLE_LOADING';
export const SIGNALS_LIST_CHANGE_MODAL_ERROR =
  'SIGNALS_LIST_CHANGE_MODAL_ERROR';

export const SIGNALS_LIST_CHANGE_RENAME_INIT =
  'SIGNALS_LIST_CHANGE_RENAME_INIT';
export const SIGNALS_LIST_CHANGE_DELETE_INIT =
  'SIGNALS_LIST_CHANGE_DELETE_INIT';
export const SIGNALS_LIST_CHANGE_EXPIRY_INIT =
  'SIGNALS_LIST_CHANGE_EXPIRY_INIT';
export const SIGNALS_LIST_CHANGE_DELETE = 'SIGNALS_LIST_CHANGE_DELETE';
export const SIGNALS_LIST_CHANGE_COMMON = 'SIGNALS_LIST_CHANGE_COMMON';
export const CREATE_SIGNAL_FORM_EDIT = 'CREATE_SIGNAL_FORM_EDIT';
export const CREATE_SIGNAL_FORM_CLEAR = 'CREATE_SIGNAL_FORM_CLEAR';
export const CREATE_SIGNAL_FORM_ERROR = 'CREATE_SIGNAL_FORM_ERROR';
export const CREATE_SIGNAL_FORM_REQUEST = 'CREATE_SIGNAL_FORM_REQUEST';

export const FETCH_SIGNAL_BY_ID_REQUEST = 'FETCH_SIGNAL_BY_ID_REQUEST';
export const FETCH_SIGNAL_BY_ID_SUCCESS = 'FETCH_SIGNAL_BY_ID_SUCCESS';
export const FETCH_SIGNAL_BY_ID_FAILURE = 'FETCH_SIGNAL_BY_ID_FAILURE';
export const CLEAR_SIGNAL_EDIT = 'CLEAR_SIGNAL_EDIT';

export const UPDATE_SELECTED_ALERT = 'UPDATE_SELECTED_ALERT';
export const SELECTED_ALERT_COKKIE = 'SELECTED_ALERT_COKKIE';

export const FETCH_SIGNAL_GROUP_ALGO_LIST_REQUEST =
  'FETCH_SIGNAL_GROUP_ALGO_LIST_REQUEST';
export const FETCH_SIGNAL_GROUP_ALGO_LIST_SUCCESS =
  'FETCH_SIGNAL_GROUP_ALGO_LIST_SUCCESS';
export const FETCH_SIGNAL_GROUP_ALGO_LIST_FAILURE =
  'FETCH_SIGNAL_GROUP_ALGO_LIST_FAILURE';

export const SIGNAL_GROUP_ALGO_LIST_CACHE = 'SIGNAL_GROUP_ALGO_LIST_CACHE';
export const SIGNAL_GROUP_ALGO_LIST_UPDATE_DAY =
  'SIGNAL_GROUP_ALGO_LIST_UPDATE_DAY';
export const SIGNAL_GROUP_ALGO_LIST_UPDATE_FILTERS =
  'SIGNAL_GROUP_ALGO_LIST_UPDATE_FILTERS';
export const SIGNAL_GROUP_ALGO_SORTING = 'SIGNAL_GROUP_ALGO_SORTING';

export const SIGNAL_GROUP_ALGO_LIST_UPDATE_LINKED_ALGOS =
  'export const SIGNAL_GROUP_ALGO_LIST_UPDATE_LINKED_ALGOS';

export const SIGNAL_GROUP_ALGO_LIST_CLEAR = 'SIGNAL_GROUP_ALGO_LIST_CLEAR';

export const SIGNAL_GROUP_ALGOS_LIST_CHANGE = 'SIGNAL_GROUP_ALGOS_LIST_CHANGE';
export const SIGNAL_GROUP_ALGOS_LIST_CONFIG_ERRORS =
  'SIGNAL_GROUP_ALGOS_LIST_CONFIG_ERRORS';
export const SIGNAL_GROUP_ALGOS_LIST_CONFIG_ERRORS_MODAL =
  'SIGNAL_GROUP_ALGOS_LIST_CONFIG_ERRORS_MODAL';

// SIGNAL_ALERT
export const FETCH_SIGNAL_ALERTS_REQUEST = 'FETCH_SIGNAL_ALERTS_REQUEST';
export const FETCH_SIGNAL_ALERTS_SUCCESS = 'FETCH_SIGNAL_ALERTS_SUCCESS';
export const FETCH_SIGNAL_ALERTS_FAILURE = 'FETCH_SIGNAL_ALERTS_FAILURE';

export const FETCH_SIGNAL_ALERT_BY_ID_REQUEST =
  'FETCH_SIGNAL_ALERT_BY_ID_REQUEST';
export const FETCH_SIGNAL_ALERT_BY_ID_SUCCESS =
  'FETCH_SIGNAL_ALERT_BY_ID_SUCCESS';
export const FETCH_SIGNAL_ALERT_BY_ID_FAILURE =
  'FETCH_SIGNAL_ALERT_BY_ID_FAILURE';

export const CREATE_SIGNAL_ALERT_SAVE_REQUEST =
  'CREATE_SIGNAL_ALERT_SAVE_REQUEST';
export const CREATE_SIGNAL_ALERT_SAVE_SUCCESS =
  'CREATE_SIGNAL_ALERT_SAVE_SUCCESST';
export const CREATE_SIGNAL_ALERT_SAVE_ERROR = 'CREATE_SIGNAL_ALERT_SAVE_ERROR';

export const CREATE_SIGNAL_ALERT_FORM_EDIT = 'CREATE_SIGNAL_ALERT_FORM_EDIT';
export const CREATE_SIGNAL_ALERT_FORM_CLEAR = 'CREATE_SIGNAL_ALERT_FORM_CLEAR';

export const SIGNALS_ALERT_CHANGE_COMMON = 'SIGNALS_ALERT_CHANGE_COMMON';

// user Orderbook
export const FETCH_USER_ORDER_BOOK_REQUEST = 'FETCH_USER_ORDER_BOOK_REQUEST';
export const FETCH_USER_ORDER_BOOK_SUCCESS = 'FETCH_USER_ORDER_BOOK_SUCCESS';
export const FETCH_USER_ORDER_BOOK_FAILURE = 'FETCH_USER_ORDER_BOOK_FAILURE';

export const UPDATE_USER_ORDER_BOOK_RETRY_AFTER_TIMER =
  'UPDATE_USER_ORDER_BOOK_RETRY_AFTER_TIMER';

export const RESET_USER_ORDER_BOOK = 'RESET_USER_ORDER_BOOK';

export const USER_ORDER_BOOK_LIST_CACHE = 'USER_ORDER_BOOK_LIST_CACHE';
export const USER_ORDER_BOOK_LIST_UPDATE_FILTERS =
  'USER_ORDER_BOOK_LIST_UPDATE_FILTERS';
export const USER_ORDER_BOOK_LIST_SORTING = 'USER_ORDER_BOOK_LIST_SORTING';

export const FETCH_ANNOUNCEMENTS_REQUEST = 'FETCH_ANNOUNCEMENTS_REQUEST';
export const FETCH_ANNOUNCEMENTS_SUCCESS = 'FETCH_ANNOUNCEMENTS_SUCCESS';
export const FETCH_ANNOUNCEMENTS_FAILURE = 'FETCH_ANNOUNCEMENTS_FAILURE';
export const DISMISS_ANNOUNCEMENT = 'DISMISS_ANNOUNCEMENT';

export const FETCH_NOTIFICATION_ALERTS_REQUEST =
  'FETCH_NOTIFICATION_ALERTS_REQUEST';
export const FETCH_NOTIFICATION_ALERTS_SUCCESS =
  'FETCH_NOTIFICATION_ALERTS_SUCCESS';
export const FETCH_NOTIFICATION_ALERTS_FAILURE =
  'FETCH_NOTIFICATION_ALERTS_FAILURE';
export const DISMISS_NOTIFICATION_ALERT = 'DISMISS_NOTIFICATION_ALERT';

// user Margin
export const FETCH_USER_MARGIN_REQUEST = 'FETCH_USER_MARGIN_REQUEST';
export const FETCH_USER_MARGIN_SUCCESS = 'FETCH_USER_MARGIN_SUCCESS';
export const FETCH_USER_MARGIN_FAILURE = 'FETCH_USER_MARGIN_FAILURE';

export const UPDATE_USER_MARGIN_RETRY_AFTER_TIMER =
  'UPDATE_USER_MARGIN_RETRY_AFTER_TIMER';

export const RESET_USER_MARGIN = 'RESET_USER_MARGIN';

export const USER_MARGIN_LIST_CACHE = 'USER_MARGIN_LIST_CACHE';
export const USER_MARGIN_LIST_UPDATE_FILTERS =
  'USER_MARGIN_LIST_UPDATE_FILTERS';
export const USER_MARGIN_LIST_SORTING = 'USER_MARGIN_LIST_SORTING';

// algo bulk errors
export const FETCH_ALGO_BULK_ERRORS_REQUEST = 'FETCH_ALGO_BULK_ERRORS_REQUEST';
export const FETCH_ALGO_BULK_ERRORS_RESET = 'FETCH_ALGO_BULK_ERRORS_RESET';
export const FETCH_ALGO_BULK_ERRORS_SUCCESS = 'FETCH_ALGO_BULK_ERRORS_SUCCESS';
export const FETCH_ALGO_BULK_ERRORS_UPDATE_DATA_CACHED =
  'FETCH_ALGO_BULK_ERRORS_UPDATE_DATA_CACHED';
export const FETCH_ALGO_BULK_ERRORS_FAILURE = 'FETCH_ALGO_BULK_ERRORS_FAILURE';
export const ALGO_BULK_ERRORS_FILTERS = 'ALGO_BULK_ERRORS_FILTERS';
export const UPDATE_ALGO_BULK_ERRORS_FILTERS =
  'UPDATE_ALGO_BULK_ERRORS_FILTERS';
export const ALGO_BULK_ERRORS_SORTING = 'ALGO_BULK_ERRORS_SORTING';
export const UPDATE_ALGO_BULK_ERRORS_SORTING =
  'UPDATE_ALGO_BULK_ERRORS_SORTING';

export const ALGO_BULK_ERRORS_UPDATE_VALUE = 'ALGO_BULK_ERRORS_UPDATE_VALUE';
export const ALGO_BULK_ERRORS_UPDATE_BULK_VALUE =
  'ALGO_BULK_ERRORS_UPDATE_BULK_VALUE';

export const ALGO_BULK_ERRORS_UPDATE_SELECT_ALL =
  'ALGO_BULK_ERRORS_UPDATE_SELECT_ALL';

export const ALGO_BULK_ERRORS_UPDATE_RETRY_ATTEMPT_COUNT =
  'ALGO_BULK_ERRORS_UPDATE_RETRY_ATTEMPT_COUNT';

export const ALGO_BULK_ERRORS_CLEAR_RETRY_ATTEMPT_COUNT =
  'ALGO_BULK_ERRORS_CLEAR_RETRY_ATTEMPT_COUNT';
